import { useContext } from "react";
import { HookOutOfContextError } from "@jugl-web/utils";
import { ChatBotContext } from "./ChatBotContext";

export const useChatBot = () => {
  const context = useContext(ChatBotContext);

  if (!context) {
    throw new HookOutOfContextError("useChatBot", "ChatBotContext");
  }

  return context;
};
